import { createStyles } from '@mui/styles';

// Utils
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
            transform: "translateY(65px)"
        },
        "100%": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },
    newBecomePartnerContainer: {
        maxWidth: 537,
        margin: '9em auto 4em',
        padding: '0 1.5em',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 768px)': {
            margin: '6em auto 4em',
        },
        '@media(max-width: 480px)': {
            margin: '4em auto 4em',
        },
    },
    newBecomePartnerContainerTitle: {
        maxWidth: 537,
        color: '#4a4a4a',
        marginBottom: 40,
        '@media(max-width: 768px)': {
            textAlign: 'center',
            margin: '0 auto 40px'
        },
        '& > h1': {
            fontSize: 26,
            lineHeight: '34px',
            letterSpacing: '-0.5px',
            margin: '0 0 10px 0',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.0rem',
            },
        },
        '& > p': {
            fontSize: 16,
            lineHeight: '24px',
            letterSpacing: '0',
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.4rem',
                lineHeight: 1.45
            },
        }
    },
    newBecomePartnerFormSteps: {
        width: '100%',
        minWidth: '320px',
        maxWidth: '537px',
        '& > div': {
            margin: 0
        },
    },
    formSectionRadio: {
        color: '#4A4A4A',
        display: 'flex',
        flexDirection: 'row',
        '& .MuiSvgIcon-root': {
            fill: theme.palette.primary.main,
            fontSize: '2.6rem'
        },
        marginBottom: 20
    },
    formSectionInput: {
        marginBottom: 25,
        width: '100%'
    },
    formSectionHeading: {
        fontWeight: 500,
        marginBottom: 20
    },
    formTermsCondition: {
        '& label': {
            width: 'auto',
            textAlign: 'center',
            margin: '0 auto 30px',
            padding: 0,
            display: 'block',
            '& .MuiCheckbox-root': {
                padding: 0,
            },
            '& .MuiTypography-body1': {
                verticalAlign: 'middle'
            }
        }
    },
    stepButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        '@media(max-width: 480px)': {
            flexDirection: 'column-reverse'
        }
    },
    stepButtonsLeft: {

    },
    stepButtonsRight: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    stepButton: {
        width: 200,
        '@media(max-width: 480px)': {
            marginBottom: 10,
            width: '100%'
        }
    },
    checkboxLink: {
        color: '#2d91e9'
    },
    loaderSpinner: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		margin: 'auto',
	},
});